import React from 'react';
import Navigation from '../components/Navigation';
import About from '../components/About';
import About2 from '../components/About2';
import Footer from '../components/Footer';
import Technos from '../components/Technos';
import Projects from '../components/Projects';
import Contact from '../components/Contact';


const Home = () => {
    return (
        <div>
            <Navigation />
            <About />
            <About2 />
            <Technos />
            <Projects />
            <Contact />
            <Footer />
        </div>
    );
};

export default Home;